@if (user(); as selected_user) {
  <div class="detail-header">
    <a mat-button routerLink="/employees/rrhh/formations/by-user">
      <mat-icon>arrow_back</mat-icon>
      Volver al listado
    </a>

    <h2 class="detail-title">{{ selected_user.name }} {{ selected_user.surnames }}</h2>

    <button mat-flat-button color="accent" type="button" (click)="openActivateDialog()">Activar formación</button>
  </div>

  @if (loading_user()) {
    <p class="loading-hint">Cargando datos…</p>
  } @else {
    <app-learning-resource-user-formation-profile [user_id]="selected_user.id" [enable_achievement_management]="true" />
  }
}
